module.exports = __webpack_public_path__ + "static/media/green_coin.94bd4deb.png";